var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("app-modal", {
    attrs: { persistent: "", "max-width": "500px" },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [_vm._v("\n    " + _vm._s(_vm.formConfig.title) + "\n  ")]
        },
        proxy: true,
      },
      {
        key: "alert",
        fn: function () {
          return [
            _c(
              "v-alert",
              {
                attrs: {
                  outline: "",
                  color: "warning",
                  icon: "warning",
                  value: _vm.shouldDisplayUpsertWarn,
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("ContinuousApprovalLevelManage.upsertWarning", {
                      msg:
                        _vm.formApprovalLevelConfiguration.MappedValue ||
                        "Default",
                    })
                  )
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "text",
        fn: function () {
          return [
            _c(
              "v-form",
              {
                ref: "form",
                model: {
                  value: _vm.formIsValidated,
                  callback: function ($$v) {
                    _vm.formIsValidated = $$v
                  },
                  expression: "formIsValidated",
                },
              },
              [
                _c("v-checkbox", {
                  attrs: {
                    label: _vm.$t(
                      "ContinuousApprovalLevelManage.defaultApprovalLevel"
                    ),
                    readonly: !_vm.isAddForm,
                  },
                  model: {
                    value: _vm.formIsDefaultApprovalLevelConfiguration,
                    callback: function ($$v) {
                      _vm.formIsDefaultApprovalLevelConfiguration = $$v
                    },
                    expression: "formIsDefaultApprovalLevelConfiguration",
                  },
                }),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    label: _vm.$t(
                      "ContinuousApprovalLevelManage.continuousDatabaseValue"
                    ),
                    rules: _vm.databaseValueRules,
                    disabled:
                      !_vm.isAddForm ||
                      _vm.formIsDefaultApprovalLevelConfiguration,
                  },
                  model: {
                    value: _vm.formApprovalLevelConfiguration.MappedValue,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formApprovalLevelConfiguration,
                        "MappedValue",
                        $$v
                      )
                    },
                    expression: "formApprovalLevelConfiguration.MappedValue",
                  },
                }),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    label: _vm.$t("ContinuousApprovalLevelManage.outputText"),
                    rules: _vm.outputTextRules,
                  },
                  model: {
                    value: _vm.formApprovalLevelConfiguration.OutputText,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formApprovalLevelConfiguration,
                        "OutputText",
                        $$v
                      )
                    },
                    expression: "formApprovalLevelConfiguration.OutputText",
                  },
                }),
                _vm._v(" "),
                _c("v-textarea", {
                  attrs: {
                    label: _vm.$t(
                      "ContinuousApprovalLevelManage.outputDescription"
                    ),
                  },
                  model: {
                    value: _vm.formApprovalLevelConfiguration.OutputDescription,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formApprovalLevelConfiguration,
                        "OutputDescription",
                        $$v
                      )
                    },
                    expression:
                      "formApprovalLevelConfiguration.OutputDescription",
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("v-spacer"),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: {
                  color: "success",
                  disabled: !_vm.formIsValidated,
                  loading: _vm.isSaving,
                },
                on: { click: _vm.save },
              },
              [
                _c("v-icon", [_vm._v("done")]),
                _vm._v("\n      " + _vm._s(_vm.$t("Button.Save")) + "\n    "),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              { attrs: { color: "secondary" }, on: { click: _vm.close } },
              [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
            ),
          ]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _vm.modal,
      callback: function ($$v) {
        _vm.modal = $$v
      },
      expression: "modal",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }